import { TextInput as MantineTextInput } from '@mantine/core';
import type { InputProps } from '../../types';
import { useDebouncedDraft } from '../../hooks/use-debounced-draft';

export const TextInput = ({ value, handleChange }: InputProps<string>) => {
  const [draft, setDraft] = useDebouncedDraft(value, handleChange);

  return (
    <MantineTextInput
      onChange={(event) => setDraft(event.target.value)}
      value={draft}
    />
  );
};
